import * as Sentry from '@sentry/vue';

import {
  SENTRY_DSN,
  NODE_ENV,
  COMMIT_HASH,
  SENTRY_TRACES_SAMPLE_RATE,
} from './config/appConfig';

/**
 * Initialize @sentry/vue with provided Vue context and router.
 * Will also attach Sentry to `window` so it's available for use globally.
 * @param {Object} app - Vue app instance.
 * @param {Object} router - Vue router instance.
 * @returns {void}
 */
export default (app, router) => {
  if (!SENTRY_DSN) { return; }

  try {
    Sentry.init({
      app,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      replaysSessionSampleRate: 0, // Don't capture replays in general.
      replaysOnErrorSampleRate: 1.0, // But capture all replays with an error.
      dsn: SENTRY_DSN,
      environment: NODE_ENV,
      release: COMMIT_HASH,
      tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
      beforeSend(event) {
        // NOTE: If filtering is needed, implement here.
        //       Returning null means the event should NOT be logged to Sentry.
        return event;
      },
    });

    window.Sentry = Sentry;
  } catch (err) { /* noop */ }
};
